import dynamic from 'next/dynamic';
const SelectLongListModal = dynamic(() => import('./selectLongListModal'), {
    ssr: false,
});
export default SelectLongListModal;
